<script lang="ts">
  import { themeStore } from '../stores/themeStore';
  import { IconSun, IconMoon } from '@tabler/icons-svelte';
  import type { Theme } from '../stores/themeStore';
  
  let currentTheme: Theme = 'dark';
  
  themeStore.subscribe((theme) => {
    currentTheme = theme;
  });
  
  function toggleTheme() {
    themeStore.toggleTheme();
  }
</script>

<button
  on:click={toggleTheme}
  class="glass-button flex items-center gap-2 px-4 py-2 rounded-lg transition-all cursor-pointer"
  aria-label={currentTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
  title={currentTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
>
  {#if currentTheme === 'dark'}
    <IconSun class="w-5 h-5" />
  {:else}
    <IconMoon class="w-5 h-5" />
  {/if}
</button>
